var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"single-card"},[_c('h1',[_vm._v("いぎなり東北産を応援する")]),(_vm.card)?_c('LargeCard',{attrs:{"card":_vm.card}}):_vm._e(),(_vm.notFound)?_c('div',[_c('p',[_vm._v("画像が見つかりません。")])]):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_c('a',{attrs:{"href":"/cards"}},[_vm._v("神経衰弱で遊ぶ")])])
}]

export { render, staticRenderFns }